import src from "IMAGE";
export default { src, width: 720, height: 700, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAAAAADhZOFXAAAAPUlEQVR42h3GwQ3AIAwDQD/BThwCSN1/01b9HSJWlyk4uztoTNWHIMZgZoQg1rZ/9LPXFOb0bUsg655T+QJ2ywNaZnLWLAAAAABJRU5ErkJggg=="};
